import { Component, Input } from '@angular/core';
import { AttachmentActivity } from '../../../../ticket.model';

/** Component for an local attachment activity */
@Component({
  selector: 'xs-local-attachment-activity',
  templateUrl: './local-attachment-activity.component.html',
  styleUrls: ['./local-attachment-activity.component.scss'],
})
export class LocalAttachmentActivityComponent {
  /** Note activity for the local attachment */
  @Input()
  public parentActivity: AttachmentActivity;

  constructor() {}
}
